<template>
    <div class="container remove-padding-margin" id="setLokasiOutlet">
        <div class="header-top bg-white">
            <div class="row justify-content-center align-items-center set-row w-limit">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                    <img src="../../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Atur Lokasi Outlet</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <main class="flex-100 w-limit">
            <div class="pad-top-50">
                <div class="pembatas remove-margin"></div>

                <div class="p-x-20 p-y-16 section-search">
                    <i class="fas fa-search search-icon"></i>
                    <input type="text" class="form-control inputs search-input"
                           v-model="search" @keyup="typing" autofocus>
                </div>

                <div class="pembatas remove-margin"></div>

                <div class="p-x-20 p-y-16 section-search" @click="getCurrentLocation">
                    <img src="../../../assets/img/current-location.svg" class="m-r-6" style="margin-top: -3px">
                    <span class="f-16 f-c-midgrey">Gunakan lokasi saya saat ini</span>
                </div>

                <div class="pembatas remove-margin"></div>
            </div>
            <div class="flex-1">
                <div class="row m-0 p-x-20 p-y-20 maps-list" v-for="item in items"
                     @click="locationSearchSelected(item)">

                    <div class="font-weight-600 f-16 letter-space-002 line-height-21 m-d-2 nomore w-100">
                        <img src="../../../assets/img/pin-outline.svg" class="m-r-8" alt="">
                        {{ item.address.name }}
                    </div>
                    <p class="f-12 f-c-midgrey letter-space-002 line-height-21 m-d-0" style="margin-left: 32px">
                        {{ item.address.full }}
                    </p>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "SetLokasiOutlet",
        data() {
            return {
                search: "",
                items: [],
	            timer: null,
            }
        },
        methods: {
            back() {
                this.$emit("back")
            },
	        getCurrentLocation() {
		        this.back()
            	this.$emit("getCurrentLocation")
	        },
	        typing() {
		        if (this.timer) {
			        clearTimeout(this.timer);
			        this.timer = null;
		        }
		        this.timer = setTimeout(() => {
			        if (this.search === "") {
			        	this.items = []
				        return
			        }
			        this.locationSearch()
		        }, 500);
	        },
            async locationSearch() {
                try {
                    this.items = [];
                    const res = await this.$axios.get(this.$baseurl + "masterData/meta/search_lokasi_maps?key_place="+encodeURI(this.search),  this.requestHeaders)
                    if (res.status) {
                        for (var i = 0; i < res.data.data.results.length; i++) {
                            this.items.push({
                                latlng: {
                                    lat: res.data.data.results[i].geometry.location.lat,
                                    lng: res.data.data.results[i].geometry.location.lng,
                                },
                                address: {
                                    name: res.data.data.results[i].name,
                                    full: res.data.data.results[i].formatted_address
                                },
                            })
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                }
            },
            locationSearchSelected(item) {
                this.search = "";
                this.items = [];
                this.$emit("setLatLng", item)
            }
        }
    }
</script>

<style scoped>
    .section-search {
        position: relative;
    }

    .search-icon {
        position: absolute;
        top: 24px;
        left: 32px;
        color: #D6D3D3;
    }

    .search-input {
        padding-left: 36px;
    }

    .maps-list {
        border-bottom: 1px solid #EDEDED;
    }
</style>